module.exports = __webpack_public_path__ + "img/top-icon-3.5802a0d9.svg";